import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import OrgRegistryComponent from '../components/org-registry.component';
import storePersist from '../../../../../../redux/storePersist';
import { deepCopy } from '../../../../../../common/services/common.service';
import { accounts } from '../../../../../../redux/accounts/action';
import { selectAccountsListItems } from '../../../../../../redux/accounts/selector';
import { shippingProviders } from '../../../../../../redux/shipping-providers/action';
import { selectShippingProvidersListItems } from '../../../../../../redux/shipping-providers/selector';
import { orgRegistries } from '../../../../../../redux/org-registries/action';
import { selectOrgRegistriesQueryItems } from '../../../../../../redux/org-registries/selector';
import { selectShippingTypesListItems } from '../../../../../../redux/shippingTypes/selector';
import { shippingTypes } from '../../../../../../redux/shippingTypes/action';

let currentChange: any = {}
const ManagementOrgRegistry = () => {   
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const orgRegistryQuery = useSelector(selectOrgRegistriesQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const accountsItems = useSelector(selectAccountsListItems)
const shippingProvidersListItems = useSelector(selectShippingProvidersListItems)
const shippingTypesListItems = useSelector(selectShippingTypesListItems)

  const [
    orgRegistry,
    setOrgRegistry
  ] = useState<any>([])
  const [
    selectedOrgRegistry,
    setSelectedOrgRegistry
  ] = useState<any>({
    Circle: {
      radius: {}
    },
    Time: {
      schedule: {},
      range: {}
    }
  })
  const [
    keys,
    setKeys
  ] = useState<any>([])

  const addNewRow = ({ selectedKeysArg }: any) => {
    const localSelectedKeys = deepCopy(selectedKeysArg)
    const newsSelectedKeysRecord = {
      Id: 0,
      signing_pvt_key: '',
      signing_pub_key: '',
      encryption_pvt_key: '',
      encryption_pub_key: ''
    }
    if (localSelectedKeys.length === 0 ||
      localSelectedKeys[localSelectedKeys?.length - 1]?.signing_pvt_key !== ''
    ) {
      localSelectedKeys?.push(newsSelectedKeysRecord)
    }

    return localSelectedKeys
  }
  const setKeysInfo = async () => {
    let localSelectedKeys = deepCopy(keys)
    localSelectedKeys.splice(
      currentChange.idx,
      1,
      { ...localSelectedKeys[currentChange.idx] }
    );
    localSelectedKeys = addNewRow({ selectedKeysArg: localSelectedKeys });
    currentChange.field = 'signing_pvt_keyDONE'
    setKeys(localSelectedKeys)
  }

  const fetchOrgRegistryById= ()=>{
    dispatch(orgRegistries.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/org-registries/query`,entity:'orgRegistries',jsonData:{
          
    Records: [
      {
        Id: parmas?.id,
        VendorId: '-1',
        UkId: '-1',
        AccountPId: '-1',
        AccountId: '-1'
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})

  }

  const fetchAcount = async (accoundTypeId: any) => {
    dispatch(accounts.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/accounts/list`,entity:'accounts',jsonData:{
      Filters: [
        {
          FieldName: 'TypeId',
          FieldValue: accoundTypeId,
          FieldType: 'number',
          FilterOperatorId: 1
        }
      ]  
  }}))
  }
  const fetchShippingProviders = async () => {
    dispatch(shippingProviders.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/shipment-management/shipping-providers/list`,entity:'shippingProviders',jsonData:{
      Filters: [
        {
          FieldName: 'IsNetworkShippingProvider',
          FilterOperatorId: 1,
          FieldValue: true,
          FieldType: 'boolean'
        }
      ]  
  }}))
  }

  useEffect(
    () => {
       fetchAcount({}).then(() => {
        fetchShippingProviders()
    })
    .then(() => {
      dispatch(shippingTypes.list({url:`https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`,entity:'shippingTypes',jsonData:{
      }}))
  })
  .then(()=>{
            if (parmas?.id > 0) {
              fetchOrgRegistryById()
                setIsLoading(false)
              }else {
                const currentSelectedKeys = addNewRow({ selectedKeysArg: keys });
                setKeys(currentSelectedKeys)
                setIsLoading(false)
              }
           
          })
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setOrgRegistry(orgRegistryQuery?.result?.items)
        const newString = orgRegistryQuery?.result?.items?.Time?.days
        const daysArray: any = newString?.split(',').map(Number);
        setSelectedOrgRegistry(
          {
            gps: orgRegistryQuery?.result?.items?.Circle?.gps,
            unit : orgRegistryQuery?.result?.items?.Circle?.radius?.unit,
            value : orgRegistryQuery?.result?.items?.Circle?.radius?.value,
            days : daysArray,
            holidays : orgRegistryQuery?.result?.items?.Time?.schedule?.holidays,
            frequency : orgRegistryQuery?.result?.items?.Time?.schedule?.frequency,
            times : orgRegistryQuery?.result?.items?.Time?.schedule?.times,
            start : orgRegistryQuery?.result?.items?.Time?.range?.start,
            end : orgRegistryQuery?.result?.items?.Time?.range?.end,
          }
        )
        const currentSelectedKeys = addNewRow({ selectedKeysArg: orgRegistryQuery?.result?.items?.Keys });
        setKeys(currentSelectedKeys)

      }
    },
    [isQuery]
  )
  const handleFormItemChange: any = ({ value, field, idx }: any) => {
    const items = deepCopy(keys);// deep copy of activity items
    let item = items[idx];// deep copy of item to be edited
    item = { ...item, [field]: value }// updated the particular item
    items[idx] = item;
    currentChange = { value, field, idx }
    setKeys(items);
  }
  const handleFormChange: any = ({ field, value }: any) => {
    currentChange = { value, field }
    setOrgRegistry({ ...orgRegistry, [field]: value })
    setSelectedOrgRegistry({ ...selectedOrgRegistry, [field]: value })
  }
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    keys.splice(
      keys.length - 1,
      1
    )
    const newString: any = selectedOrgRegistry?.days.map((x: any) => x).join(',')
    const orgRegistryData ={

      Id: orgRegistry?.Id || 0,
      IsAcceptOrderByDefaultEnabled: orgRegistry?.IsAcceptOrderByDefaultEnabled || true,
      IsDirectShipmentEnabled: orgRegistry?.IsDirectShipmentEnabled || true,
      Keys: keys || [],
      UkId: orgRegistry?.UkId || '',
      Delivery_preference: orgRegistry?.Delivery_preference || '',
      Circle: {
        gps: selectedOrgRegistry?.gps || '',
        radius: {
          unit: selectedOrgRegistry?.unit || '',
          value: selectedOrgRegistry?.value || ''
        }
      },
      Time: {
        days: newString || '',
        schedule: {
          holidays: selectedOrgRegistry?.holidays || [],
          frequency: selectedOrgRegistry?.frequency || '',
          times: selectedOrgRegistry?.times || []
        },
        range: {
          start: selectedOrgRegistry?.start || '',
          end: selectedOrgRegistry?.end || ''
        }
      },
      CurrentlyServicing: orgRegistry?.CurrentlyServicing || false,
      UseSettingsFromConfigFile: orgRegistry?.UseSettingsFromConfigFile || false,
      Stdcode: 'string',
      AccountId: orgRegistry?.AccountId || 0,
      AccountTypeId: orgRegistry?.AccountTypeId || 0,
      PreferredLogisticProviderAccountIds: orgRegistry?.PreferredLogisticProviderAccountIds || [],
      ShippingTypeId: orgRegistry?.ShippingTypeId || 0
      
    }
    if (parmas?.id > 0) {
     dispatch(orgRegistries.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/org-registries`,entity:'orgRegistries',jsonData:{
          
    Records: [
        orgRegistryData
    ]
 
}})).then(()=>{
    back()
  })
  

    }else{
      dispatch(orgRegistries.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/dbn/org-registries`,entity:'orgRegistries',jsonData:{
          
      Records: [
        orgRegistryData
      ]
    
  }})).then(()=>{
    back()
  })
  
    }
   
    
  }

const back=()=>{
  navigate('/management/organization/dbn/org-registries')
} 
const libraryListItems = storePersist?.get("library")?.current;

const deleteKeys = async (Item: any, index: any) => { 
  const card = deepCopy(keys)
  card?.splice(
    index,
    1
  )
}
useEffect(
  () => {
    if (currentChange.field === 'signing_pvt_key') {
      setKeysInfo()
    }
  },
  [keys]
)
    return (
    <>
     {isLoading ? <PageLoader /> : 
          <OrgRegistryComponent 
          deleteKeys={deleteKeys}
          accountType={libraryListItems.Type}
          deliveryPreference={libraryListItems.DeliveryPreference}
          onFormItemChange={handleFormItemChange}
          keys={keys}
          onFormChange={handleFormChange}
          orgRegistry={orgRegistry}
          fetchAcount={fetchAcount}
          accounts={accountsItems?.result?.items}
          shippingProviders={shippingProvidersListItems?.result?.items}
          id={parmas.id}
          selectedOrgRegistry={selectedOrgRegistry}
          shippingTypes={shippingTypesListItems?.result?.items}
          back={back}
          handleFormSubmit={handleFormSubmit}
          /> 
        } 
          </>
    )
    
    }
   
    export default ManagementOrgRegistry;